import { useEffect, useState } from "react";

const FrontEndProcessing = () => {
  const [state, setState] = useState("");

  // Function to call the API
  const callApi = (status) => {
    console.log("status ===>>>>>", status);
    setState(status);
    // API logic here
  };

  useEffect(() => {
    callApi("Online");

    const handleError = () => {
      callApi("Offline");
    };

    window.addEventListener("error", handleError);

    return () => {
      window.removeEventListener("error", handleError);
    };
  }, []);

  return (
    <h1>
      Status : {
        state
      }

    </h1>
  );
};

export default FrontEndProcessing;
